import React, { FunctionComponent, CSSProperties } from 'react';
import ScoreStar from '../ScoreStar';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';

interface IProps {
  score: number;
  intlId: string;
  defaultMessage: string;
  color?: string;
}

const AvgScore: FunctionComponent<IProps> = ({ color = 'var(--neutral-800)', score, intlId, defaultMessage }) => (
  <div style={{ '--star-color': color } as CSSProperties} className={styles.scoreWrp}>
    <span className={`t-14 ${styles.label}`}>
      <FormattedMessage id={intlId} defaultMessage={defaultMessage} />
    </span>
    <div className={styles.score}>
      <ScoreStar score={score} variant="secondary" />
    </div>
  </div>
);

export default AvgScore;
